module.exports = __webpack_public_path__ + "img/not-sure.cf4953e2.jpeg";